import React, { Component } from 'react'

class Rotate extends Component {
  constructor(props) {
		super(props)

		this.state = {
      isResizing: false
		}
	}

  componentDidMount() {
    window.addEventListener('mousemove', this.handleMouseMove)
    window.addEventListener('mouseup', this.handleMouseUp)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('mouseup', this.handleMouseUp)
  }

  handleMouseMove = () => {
    if (this.state.isResizing) {
      const delta_x_global = event.movementX
      const delta_y_global = event.movementY

      this.onResizing({x: delta_x_global, y: delta_y_global})
    }
  }

  handleMouseUp = () => {
    const { isResizing } = this.state

    if (isResizing) this.setState({isResizing: false}, () => {
      this.props.editRiderStageplanItem()
      this.props.onResizeEnd()
    })
  }

  onResizing = (dimensions) => {
    let { attributes } = this.props

    const currentRotation = -attributes.radians

    const currentLocalTopLeft = {
      top: -attributes.height/2,
      left: -attributes.width/2
    }

    const currentRotatedTopLeft = {
      left: currentLocalTopLeft.left * Math.cos(currentRotation) - (currentLocalTopLeft.top * Math.sin(currentRotation)),
      top: currentLocalTopLeft.left * Math.sin(currentRotation) + currentLocalTopLeft.top * Math.cos(currentRotation)
    }

    const currentTopLeftDelta = {
      x: currentRotatedTopLeft.left - currentLocalTopLeft.left,
      y: currentRotatedTopLeft.top - currentLocalTopLeft.top
    }

    const currentGlobalRotatedTopLeft = {
      top: attributes.y + currentTopLeftDelta.y,
      left: attributes.x + currentTopLeftDelta.x
    }

    const delta_mouse = Math.sqrt(Math.pow(dimensions.x, 2) + Math.pow(dimensions.y, 2))

    const theta_global =  Math.atan2(dimensions.y, dimensions.x)

    const theta_local = currentRotation - theta_global

    const delta_x_local = Math.cos(theta_local) * delta_mouse
    const delta_y_local = -Math.sin(theta_local) * delta_mouse

    const newWidth = attributes.width + delta_x_local
    const newHeight = attributes.height + delta_y_local

    const newLocalTopLeft = {
      top: -newHeight/2,
      left: -newWidth/2
    }

    const newRotatedTopLeft = {
      top: newLocalTopLeft.left * Math.sin(currentRotation) + newLocalTopLeft.top * Math.cos(currentRotation),
      left: newLocalTopLeft.left * Math.cos(currentRotation) - (newLocalTopLeft.top * Math.sin(currentRotation))
    }

    const newTopLeftDelta = {
      x: newRotatedTopLeft.left - newLocalTopLeft.left,
      y: newRotatedTopLeft.top - newLocalTopLeft.top
    }

    const newGlobalTopLeft = {
      top: currentGlobalRotatedTopLeft.top - newTopLeftDelta.y,
      left: currentGlobalRotatedTopLeft.left - newTopLeftDelta.x
    }

    this.props.onResize({
      y: newGlobalTopLeft.top,
      x: newGlobalTopLeft.left,
      pxWidth: newWidth,
      pxHeight: newHeight
    })
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="resize-handle" onMouseDown={(e) => this.setState({isResizing: true}, this.props.onResizeStart())} />
      </div>
    )
  }
}

export default Rotate



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/resize.js